import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded'
import './ConfirmDialog.scss'

// In-app replacement for window.confirm on this page's destructive actions:
// the same modal language as MarkSoldModal, with an explicit Cancel/Delete.
// `choices` ([{value, label}]) makes the rep pick one before confirming; the
// pick is handed to onConfirm. `tone="primary"` is for non-destructive confirms.
// `sx` lifts it above another modal (e.g. the Desking grid).
export const ConfirmDialog = ({ open, title, message, confirmLabel = 'Delete', tone = 'danger', choices, onCancel, onConfirm, sx }) => {
    const [choice, setChoice] = useState(null)
    const primary = tone === 'primary'
    return (
        <Dialog open={open} onClose={onCancel} maxWidth={false} sx={sx} PaperProps={{ className: primary ? 'cdv-confirm is-primary' : 'cdv-confirm' }}>
            <div className="confirm-head">
                <div className="confirm-ic">{primary ? <HelpOutlineRoundedIcon /> : <WarningAmberRoundedIcon />}</div>
                <div>
                    <div className="confirm-title">{title}</div>
                    <div className="confirm-message">{message}</div>
                    {choices && (
                        <div className="confirm-choices" role="radiogroup" aria-label={title}>
                            {choices.map((c) => (
                                <label key={String(c.value)} className="confirm-choice">
                                    <input
                                        type="radio"
                                        name="confirm-choice"
                                        checked={choice === c.value}
                                        onChange={() => setChoice(c.value)}
                                    />
                                    <span>{c.label}</span>
                                </label>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <div className="confirm-actions">
                <button className="confirm-cancel" onClick={onCancel}>Cancel</button>
                <button
                    className={primary ? 'confirm-primary' : 'confirm-delete'}
                    disabled={Boolean(choices) && choice === null}
                    onClick={() => onConfirm(choice)}
                >{confirmLabel}</button>
            </div>
        </Dialog>
    )
}
